import React, { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import TmcApplicationsList from "../../components/TMCApplications/TmcApplicationsList";
import TmcApplicationForm from "../../components/TMCApplications/TmcApplicationsForm";
import TmcApplicationsService from "../../services/tmcApplicationService";
import MenuService from "../../services/menuService";
import { hasItemSubmenu } from "../../utils/permissions";
import MarketingService from "../../services/marketingService";

const TmcApplicationsContainer = ({ mode = "mine" }) => {
  const [applications, setApplications] = useState([]);
  const [products, setProducts] = useState([]);
  const [onOpen, setOnOpen] = useState(false);
  const userId = Number(localStorage.getItem("userId"));
  const userName = localStorage.getItem("screenname");
  const [canManageApplications, setCanManageApplications] = useState(false);

  const getApplications = useCallback(async () => {
    try {
      const sendData = {
        userId,
        scope: mode,
      };
      const data = await TmcApplicationsService.getAllApplications(sendData);
      if (data?.code >= 400 || data?.data?.error) throw new Error(data?.resp);
      setApplications(data.applications);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "No se pudieron cargar las solicitudes",
        text: "Revisá la consola / Network para más detalles.",
      });
    }
  }, [mode, userId]);

  const getProducts = useCallback(async () => {
    if (mode !== "mine") return;
    try {
      const data = await MarketingService.getTmcStock();
      setProducts(data.getTmcStock || []);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo cargar el catálogo TMC.", "error");
    }
  }, [mode]);

  useEffect(() => {
    const fetchAccess = async () => {
      try {
        const access = await MenuService.getUserMenus(userId);
        setCanManageApplications(hasItemSubmenu(access, "Solicitudes TMC"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchAccess();
    getApplications();
    getProducts();
  }, [getApplications, getProducts, userId]);

  const handleOpenForm = () => {
    setOnOpen(true);
  };

  const handleCloseForm = () => {
    setOnOpen(false);
  };

  const handleSubmit = async (formData) => {
    const data = {
      details: formData.details,
      stockId: formData.stockId,
      userId,
    };
    try {
      const response = await TmcApplicationsService.newApplications(data);
      if (response?.code >= 400 || response?.data?.error) throw new Error(response?.resp);

      Swal.fire({
        icon: "success",
        title: "Solicitud guardada",
        text: "La solicitud TMC fue registrada correctamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "No se pudo guardar",
        text: "Revisá la consola / Network para más detalles.",
      });
      handleCloseForm();
    } finally {
      getApplications();
      handleCloseForm();
    }
  };

  const ApprobeApplications = async (applicationId) => {
    const result = await Swal.fire({
      title: "Puede Aprobar o Rechazar esta solicitud",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Aprobar",
      denyButtonText: "Rechazar",
    });

    if (!result.isConfirmed && !result.isDenied) {
      return; // cancelado
    }

    const status = result.isConfirmed ? 2 : 3;
    const statusData = { status, applicationId, userId };

    Swal.fire({
      title: "Guardando...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await TmcApplicationsService.updateApplications(statusData);
      if (response?.code >= 400 || response?.data?.error) throw new Error(response?.resp);

      //exito
      await Swal.fire({
        icon: "success",
        title: result.isConfirmed
          ? "Solicitud aprobada"
          : "Solicitud rechazada",
        text: result.isConfirmed && response.emailSent === false
          ? "La solicitud se aprobó, pero no se pudo enviar la notificación por email."
          : undefined,
        timer: response.emailSent === false ? undefined : 1400,
        showConfirmButton: false,
      });

      await getApplications();
    } catch (err) {
      console.error("updateApplications error:", err);
      await Swal.fire({
        icon: "error",
        title: "No se pudo actualizar",
        text: "Revisá la consola / Network para más detalles.",
      });
    }
  };

  return (
    <>
      <TmcApplicationsList
        data={applications}
        onOpen={mode === "mine" ? handleOpenForm : null}
        ApprobeApplications={ApprobeApplications}
        canManageApplications={mode === "manage" && canManageApplications}
        mode={mode}
      />

      <TmcApplicationForm
        onOpen={onOpen}
        onClose={handleCloseForm}
        userName={userName}
        onSubmit={handleSubmit}
        products={products}
      />
    </>
  );
};

export default TmcApplicationsContainer;
